import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ModiFaceWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 6.25rem;
  height: 6.25rem;
  border-radius: 50%;

  background: rgba(0, 0, 0, 0.75);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  font-size: 0.75rem;
  color: ${theme.color.text.inverse};
  font-weight: normal;
  padding: 0.25rem 10%;
`;
